import React, { useState, history, useEffect } from "react";
import axios from "axios";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import { useHistory, Link } from "react-router-dom";
import HeaderEtd from '../../../shared/components/HeaderEtd';
import DataEnquiry from "../../enquiry/components/DataEnquiryPortal";
import Button from "@mui/material/Button";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FaUserPlus, FaUserCog } from "react-icons/fa";
//import { remSessionNextPage, url } from '../../../shared/utils/storage';
//import "./printOut/assets/bill.css";
//table
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
//end table

function Administration() {
  //remSessionNextPage();

  const [etd, setEtd] = useState({});
  let appId = etd.AppId;
  const [search, setSearch] = useState([]);
  const searchId = {
    search: search,
  };

  /*========== clear field ============*/
  const [inputValue, setInputValue] = useState("");
  const handleUserInput = (e) => {
    setInputValue(e.target.value);
  };
  const resetInputField = () => {
    setInputValue("");
  };
  /*======= end of clear field ========*/

  const [Administration, setAdministration] = useState({
    PFNo: "",
    FirstName: "",
    MiddleName: "",
    FamilyName: "",
    BirthCountryID: "",
    BirthTritoryID: "",
    mkoa: "",
    DistrictID: "",
    BirthWardID: "",
    BirthVillage: "",
    EmailID: "",
    PhoneNo: "",
    LevelID: "",
    ApplicationID: appId,
  });

  const handleChange = (e) => {
    const data = { ...Administration };
    data[e.target.name] = e.target.value;
    setAdministration(data);
  };

  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <div className="card-body">
                <h2 style={{ color: "#c2c2c2" }}>
                  <i>Administration Module</i>
                </h2>
              </div>
              <div className="card2">
                <div className="card-body">
                  <div className="row">
                    <div className="container">
                      <Box textAlign="center">
                        <Link to="/applicationmngt">
                          <Button variant="outlined" color="warning">
                            Application Management
                          </Button>
                        </Link>
                        &nbsp;&nbsp;
                        <Link to="/stockmngt">
                          <Button variant="outlined" color="warning">
                            Stock Management
                          </Button>
                        </Link>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default Administration;
